export default __webpack_public_path__ + "static/media/autro-guard.2bc16f20.jpg";